module.exports = __webpack_public_path__ + "static/media/reportingicon.07926a4d.png";